import { Component, EventEmitter, Output } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AnalyticsService } from 'src/app/services/analytics/analytics.service';

@Component({
  selector: 'app-login-success-modal',
  templateUrl: './login-success-modal.component.html',
  styleUrls: ['./login-success-modal.component.scss'],
})
export class LoginSuccessModalComponent {
  @Output() continueBooking = new EventEmitter<void>();

  constructor(
    private modalController: ModalController,
    private analyticsService: AnalyticsService
  ) {}

  onContinueBooking() {
    this.analyticsService.trackUnified('continue_booking_clicked', {
      flow: 'auth',
      outcome: 'success',
      legacy_event_name: 'Continue booking - login_success_modal',
      component: 'login_success_modal',
    });
    this.continueBooking.emit();
    this.dismiss(true);
  }

  dismiss(continueBooking: boolean = false) {
    this.modalController.dismiss({
      continueBooking: continueBooking,
    });
  }
}
